import React from 'react';
import { Box } from '@chakra-ui/react';

import { useImaginationRoom } from '@invitato/imagination-room';
import useLang from '@/hooks/useLang';
import {
  GIRL_NAME,
  BOY_NAME,
  IG_GIRL,
  IG_BOY,
  GIRL_PARENT_NAME,
  BOY_PARENT_NAME,
  IS_BOY_FIRST,
  GIRL_NAME_SHORT,
  BOY_NAME_SHORT,
} from '@/constants';
import { IMG_GIRL, IMG_MAN } from '@/constants/assets';

import kawungImg from '@/assets/icons/kawung.svg';

import DetailCouple from './DetailCard';
import { ENABLE_LOVE_STORY } from '@/constants/feature-flags';

function DualPhoto({ ...rest }) {
  const { onGetFinalContent, onGetFinalName } = useImaginationRoom();
  const lang = useLang();

  const DetailGroom = ({ index }) => {
    return (
      <DetailCouple
        instagramId={IG_BOY}
        fullName={onGetFinalName('groomFullName', BOY_NAME)}
        shortName={onGetFinalName('groomName', BOY_NAME_SHORT)}
        parentName={BOY_PARENT_NAME[lang]}
        imgUrl={onGetFinalContent('IMG_MAN', IMG_MAN)}
        i={index}
      />
    );
  };

  const DetailBride = ({ index }) => {
    return (
      <DetailCouple
        instagramId={IG_GIRL}
        fullName={onGetFinalName('brideFullName', GIRL_NAME)}
        shortName={onGetFinalName('brideName', GIRL_NAME_SHORT)}
        parentName={GIRL_PARENT_NAME[lang]}
        imgUrl={onGetFinalContent('IMG_GIRL', IMG_GIRL)}
        i={index}
      />
    );
  };

  return (
    <Box minHeight="100vh" position="relative" {...rest}>
      {IS_BOY_FIRST ? <DetailGroom index={0} /> : <DetailBride index={0} />}
      {IS_BOY_FIRST ? <DetailBride index={1} /> : <DetailGroom index={1} />}
      {!ENABLE_LOVE_STORY && (
        <Box
          width="100%"
          height={{ lg: '150px', '3sm': '150px', '1sm': '220px', sm: '200px' }}
          // marginTop={{ lg: '-0', '3sm': '-48px', '1sm': '-100px', sm: '-40px' }}
          position="relative"
          zIndex="1"
        >
          <Box
            pos="absolute"
            bottom="0"
            width="100%"
            height="80%"
            bgImage="linear-gradient(to top, #FFF7ED, transparent)"
            zIndex="2"
          />
          <Box
            pos="absolute"
            bottom="0"
            left="0"
            width="100%"
            height={{ '3sm': '60%', '2sm': '40%', sm: '30%' }}
            bgImage={kawungImg}
            bgSize="contain"
            bgPos="top center"
            bgRepeat="repeat-x"
            zIndex="5"
          />
        </Box>
      )}
    </Box>
  );
}

export default DualPhoto;
